import React, { useState } from 'react';
import Modal from "react-bootstrap/Modal";
import { postAnulacionReversionOrdenApi, postSolicitudAnulacionOrdenApi } from "../../../api/axios";
import { toast } from '../../../utilities/appToast';
import { hasMetodoPagoPermitido, idEstadosOrden, normalizeIdEstadoOrden } from "../../../helper/ordenHelper";
import PropTypes from 'prop-types';

const BTN = Object.freeze({ CON_DEVOL: 1, SIN_DEVOL: 2, RECHAZO: 3 });
/** EnumTipoEntidad: Decidir=8, MercadoPagoBilletera=14, GiftCard=19 — misma lógica de anulación que Decidir */
const esAnulacionMismaLogicaQueDecidir = (idTipoEntidad) =>
  [8, 14, 19].includes(Number(idTipoEntidad));
const METODOS_PERMITIDOS = Object.freeze([
  'TARJETA DE CRÉDITO',
  'TARJETA DÉBITO',
  'CONTADO A TRAVÉS DE COBROEXPRESS O DEPÓSITO Y/O TRANSFERENCIA BANCARIA',
  'MERCADOPAGO BILLETERA'
]);

export default function AnulacionReversion({
  idOrden,
  idSeller,
  motivosRechazo = [],
  motivoAnulacionSeller,
  goToOrdenes,
  orden,
  setHabilitarInputs,
  setHabilitarInputsVte,
  isCategory = false,
  isAdminMod = false,
  motivosSolicitudAnulacion = [],
  idMotivoAnulacion = "",
  setIdMotivoAnulacion,
}) {

  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [modalAccion, setModalAccion] = useState(null);

  const abrirFormularioDevolucion = (setter) => {
    if (typeof setter !== "function") return;
    window.setTimeout(() => setter(true), 250);
  };

  const enviarSolicitudAnulacion = (request, continuarConReversion = false) => {
    setIsFetching(true);
    return postSolicitudAnulacionOrdenApi(request)
      .then(() => {
        toast.success("Anulación enviada correctamente");
        if (continuarConReversion) {
          return postAnulacionReversionOrdenApi(request).then(() => {
            toast.success("Estado de orden actualizado");
            goToOrdenes();
          });
        }
      })
      .catch(err => {
        const errs = err?.response?.data?.errores;
        if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
        else toast.error("No se pudo enviar la solicitud o actualizar el estado");
      })
      .finally(() => setIsFetching(false));
  };

  const idMotivoResuelto = () =>
    Number(
      motivoAnulacionSeller?.idMotivo ??
        orden?.motivoAnulacion?.idMotivo ??
        orden?.motivoAnulacion?.id ??
        0
    );

  const isValidRechazo = (buttonId) => {
    if (buttonId === BTN.RECHAZO) {
      if (!motivoRechazo) {
        toast.warn("Seleccione un motivo de rechazo");
        return false;
      }
    } else if (buttonId === BTN.CON_DEVOL || buttonId === BTN.SIN_DEVOL) {
      if (!idMotivoResuelto()) {
        toast.warn("Seleccione un motivo de anulación");
        return false;
      }
    }
    return true;
  };

  const postAnulacion = (buttonId) => {
    const cupones = orden?.pago?.cupones ?? [];
    const tieneCupones = cupones.length > 0;
    const metodoPermitido = hasMetodoPagoPermitido(cupones, METODOS_PERMITIDOS);

    if (
      buttonId === BTN.CON_DEVOL &&
      orden?.pago?.cupones?.some(c => !esAnulacionMismaLogicaQueDecidir(c.idTipoEntidad))
    ) {
      const idMotivo = Number(motivoAnulacionSeller?.idMotivo || 0)
      if (!idMotivo) {
        toast.warn("La solicitud de anulación no tiene motivo");
        return;
      }
      if (metodoPermitido) {
        abrirFormularioDevolucion(setHabilitarInputs);
        return;
      }
      if (!metodoPermitido && tieneCupones) {
        const req = { idVenta: idOrden, idSeller, idMotivoAnulacion: 1, solicitarAnulacion: true };
        return enviarSolicitudAnulacion(req, true);
      }
      if (!tieneCupones) {
        abrirFormularioDevolucion(setHabilitarInputsVte);
        return;
      }
    } else if (!tieneCupones && buttonId !== BTN.SIN_DEVOL) {
        abrirFormularioDevolucion(setHabilitarInputsVte);
        return;
      }

    if (buttonId === BTN.SIN_DEVOL || (
      buttonId === BTN.CON_DEVOL &&
      orden?.pago?.cupones?.some(c => esAnulacionMismaLogicaQueDecidir(c.idTipoEntidad))
    )) {
      const idMotivo = Number(motivoAnulacionSeller?.idMotivo) || Number(orden.motivoAnulacion.idMotivo);
      if (!idMotivo && orden?.motivoAnulacion?.idMotivo === 0) {
          toast.warn("La solicitud de anulación no tiene motivo");
          return;
      }

      const requestAnulacion = {
        idVenta: orden.idOrden,
        idSeller: idSeller,
        idMotivoAnulacion: idMotivo,
        solicitarAnulacion: true
      };

      const requestMin = {
        idVenta: orden.idOrden,
        devolucionDinero: buttonId === BTN.CON_DEVOL,
        //devolucionDinero: false,
        rechazado: false,
        idSeller: idSeller,
        idMotivoAnula: idMotivo,
      };

      setIsFetching(true);
      if (orden?.motivoAnulacion?.idMotivo !== 0) {
        // Solo ejecuta esto si el motivo es distinto de 0
        postAnulacionReversionOrdenApi(requestMin)
          .then(() => {
            toast.success("Solicitud de anulación enviada");
            goToOrdenes();
          })
          .catch(err => {
            const errs = err?.response?.data?.errores;
            if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
            else toast.error("No se pudo enviar la solicitud");
          })
          .finally(() => setIsFetching(false));
      } else {
        // Si el motivo es 0, sigue el flujo anterior
        postSolicitudAnulacionOrdenApi(requestAnulacion)
          .then(res => {
            toast.success("Solicitud de anulación enviada");
            return postAnulacionReversionOrdenApi(requestMin)
              .then(() => {
                  toast.success("Solicitud de anulación enviada");
                goToOrdenes();
              });
          })
          .catch(err => {
            const errs = err?.response?.data?.errores;
            if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
            else toast.error("No se pudo enviar la solicitud");
          })
          .finally(() => setIsFetching(false));
      }
    }

    if (buttonId === BTN.RECHAZO) {
      if (!motivoRechazo) {
        toast.warn("Seleccione un motivo de rechazo");
        return;
      }
      const reqRechazo = {
        idVenta: idOrden,
        idSeller,
        idMotivoAnula: 1,
        devolucionDinero: false,
        rechazado: true,
      };

      setIsFetching(true);
      return postAnulacionReversionOrdenApi(reqRechazo)
        .then(() => {
          toast.success("Rechazo de anulación enviado");
          goToOrdenes();
        })
        .catch(err => {
          const errs = err?.response?.data?.errores;
          if (Array.isArray(errs) && errs.length) errs.forEach(e => toast.error(e));
          else toast.error("No se pudo rechazar la anulación");
        })
        .finally(() => setIsFetching(false));
    }
  };

  const existeAnulado = orden?.estado?.some(
    (e) => normalizeIdEstadoOrden(e?.idEstado ?? e?.IdEstado) === idEstadosOrden.anulado
  );
  /** Megatone (category): solicitud pendiente y motivo del seller — aprobar/rechazar anulación */
  const enSolicitudAnulacion =
    normalizeIdEstadoOrden(orden?.estado?.[0]?.idEstado ?? orden?.estado?.[0]?.IdEstado) === idEstadosOrden.solicitarAnulacion;
  const idMotivoSeller = Number(
    orden?.motivoAnulacion?.idMotivo ?? orden?.motivoAnulacion?.id ?? 0
  );
  const mostrarRechazoAnulacion =
    isCategory && enSolicitudAnulacion && idMotivoSeller !== 0;
  const ordenAnulada = Boolean(orden?.anulacionMegatone?.anulado || existeAnulado);
  const mostrarSelectorMotivoAnulacion = (isCategory || isAdminMod) && !ordenAnulada;
  const motivoSeleccionado = idMotivoAnulacion !== "" && idMotivoAnulacion !== undefined
    ? idMotivoAnulacion
    : (orden?.motivoAnulacion?.idMotivo ?? orden?.motivoAnulacion?.id ?? "");

  const handleMotivoAnulacion = (e) => {
    if (setIdMotivoAnulacion) {
      setIdMotivoAnulacion(e.target.value);
    }
  };

  const botonesAnulacion = [
    { id: BTN.CON_DEVOL, label: "Anular con devolución" },
    { id: BTN.SIN_DEVOL, label: "Anular sin devolución" },
  ];
  const accionActiva = botonesAnulacion.find((button) => button.id === modalAccion)
    || (modalAccion === BTN.RECHAZO ? { id: BTN.RECHAZO, label: "Rechazar anulación" } : null);

  const confirmarAccion = () => {
    if (!isValidRechazo(modalAccion)) return;
    const buttonId = modalAccion;
    setModalAccion(null);
    window.setTimeout(() => postAnulacion(buttonId), 250);
  };

  const renderSelectorMotivo = (selectId) => (
    <div>
      <label htmlFor={selectId} className="form-label small text-secondary mb-1">Motivo de anulación / devolución</label>
      <select
        id={selectId}
        className="form-control form-control-sm"
        value={motivoSeleccionado}
        onChange={handleMotivoAnulacion}
        disabled={isFetching}
      >
        <option value="">Seleccione motivo</option>
        {(motivosSolicitudAnulacion || []).map((motivo) => (
          <option key={motivo.id} value={motivo.id}>
            {motivo.descripcion}
          </option>
        ))}
      </select>
      {(motivosSolicitudAnulacion || []).length === 0 && (
        <small className="text-muted">No se cargaron motivos. Si el listado no aparece, recargá la orden.</small>
      )}
    </div>
  );

  if (ordenAnulada) {
    return null;
  }

  return (
    <div className="row mb-3">
      <div className="col-12">
        <div className="card border shadow-sm">
          <div className="card-body">
            <h6 className="mb-1">Anulación y devolución</h6>
            <p className="small text-muted mb-3">Elegí el motivo y confirmá si la anulación es con o sin devolución.</p>
            <div className="d-flex align-items-end flex-wrap gap-3">
              {mostrarSelectorMotivoAnulacion && (
                <div className="flex-grow-1" style={{ minWidth: "220px", maxWidth: "360px" }}>
                  {renderSelectorMotivo("motivoAnulacionAnulacionReversion")}
                </div>
              )}
              {botonesAnulacion.map((button) => (
                <button
                  key={button.id}
                  type="button"
                  className="btn btn-sm background-rojo-megatone"
                  disabled={isFetching}
                  onClick={() => setModalAccion(button.id)}
                >
                  {button.label}
                </button>
              ))}

              {mostrarRechazoAnulacion && (
                <>
                  <button
                    type="button"
                    className="btn btn-sm background-rojo-megatone"
                    disabled={isFetching}
                    onClick={() => setModalAccion(BTN.RECHAZO)}
                  >
                    Rechazar anulación
                  </button>
                  <div style={{ minWidth: 220 }}>
                    <label htmlFor="motivoRechazoAnulacionReversion" className="form-label small text-secondary mb-1">Motivo de rechazo</label>
                    <select
                      id="motivoRechazoAnulacionReversion"
                      className="form-control form-control-sm"
                      value={motivoRechazo}
                      onChange={(e) => setMotivoRechazo(e.target.value)}
                    >
                      <option value="">Seleccione motivo</option>
                      {motivosRechazo?.map((motivo) => (
                        <option key={motivo.id ?? motivo.codigo} value={motivo.id ?? motivo.codigo}>
                          {motivo.descripcion}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <Modal show={modalAccion != null} onHide={() => setModalAccion(null)} centered>
          <Modal.Header closeButton>
            <Modal.Title>{accionActiva?.label || "Confirmar anulación"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-3">
              {modalAccion === BTN.RECHAZO
                ? "¿Desea rechazar la anulación?"
                : `¿Desea ${String(accionActiva?.label || "anular").toLowerCase()}?`}
            </p>
            {modalAccion !== BTN.RECHAZO && renderSelectorMotivo("motivoAnulacionModalDevolucion")}
            {modalAccion === BTN.RECHAZO && (
              <div>
                <label htmlFor="motivoRechazoModalDevolucion" className="form-label small text-secondary mb-1">Motivo de rechazo</label>
                <select
                  id="motivoRechazoModalDevolucion"
                  className="form-control form-control-sm"
                  value={motivoRechazo}
                  onChange={(e) => setMotivoRechazo(e.target.value)}
                >
                  <option value="">Seleccione motivo</option>
                  {motivosRechazo?.map((motivo) => (
                    <option key={motivo.id ?? motivo.codigo} value={motivo.id ?? motivo.codigo}>
                      {motivo.descripcion}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-grey btn-sm" onClick={() => setModalAccion(null)}>
              Cerrar
            </button>
            <button
              type="button"
              className="btn background-rojo-megatone btn-sm"
              onClick={confirmarAccion}
              disabled={isFetching}
            >
              Aceptar
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
AnulacionReversion.propTypes = {
    idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idMotivoAnulacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    motivosRechazo: PropTypes.array,
    motivoAnulacionSeller: PropTypes.shape({
        idMotivo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    isCategory: PropTypes.bool,
    isAdminMod: PropTypes.bool,
    goToOrdenes: PropTypes.func,
    orden: PropTypes.shape({
        pago: PropTypes.shape({
            cupones: PropTypes.array,
        }),
        motivoAnulacion: PropTypes.shape({
            idMotivo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        estado: PropTypes.array,
        anulacionMegatone: PropTypes.shape({
            anulado: PropTypes.bool,
        }),
    }),
    motivosSolicitudAnulacion: PropTypes.array,
    setHabilitarInputs: PropTypes.func,
    setHabilitarInputsVte: PropTypes.func,
    setIdMotivoAnulacion: PropTypes.func,
}